import { msg, personalIdentityNumberSchema } from '~/utils/validation';
import { z } from 'zod';

export const baseSchema = z.object({
  first_name: z.string().min(1, { message: msg.required }),
  last_name: z.string().min(1, { message: msg.required }),
});

export const schema = z
  .object({
    ssn: personalIdentityNumberSchema,
    club: z.tuple([z.string(), z.number()], { message: msg.required }),
    is_para: z.boolean().optional(),
    is_ifn: z.boolean().optional(),
  })
  .merge(baseSchema);

export type Schema = z.infer<typeof schema>;
